var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidedAudioActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.73047C7.87833 2.73047 5.8435 3.57332 4.34321 5.07362C2.84292 6.57391 2.00006 8.60874 2.00006 10.7305H5.00006C5.53049 10.7305 6.0392 10.9412 6.41428 11.3163C6.78935 11.6913 7.00006 12.2 7.00006 12.7305V17.7305C7.00006 18.2609 6.78935 18.7696 6.41428 19.1447C6.0392 19.5198 5.53049 19.7305 5.00006 19.7305H2.00006C1.46963 19.7305 0.96092 19.5198 0.585847 19.1447C0.210775 18.7696 6.10352e-05 18.2609 6.10352e-05 17.7305V10.7305C6.10352e-05 5.20747 4.47706 0.730469 10.0001 0.730469C15.5231 0.730469 20.0001 5.20747 20.0001 10.7305V17.7305C20.0001 18.2609 19.7893 18.7696 19.4143 19.1447C19.0392 19.5198 18.5305 19.7305 18.0001 19.7305H15.0001C14.4696 19.7305 13.9609 19.5198 13.5858 19.1447C13.2108 18.7696 13.0001 18.2609 13.0001 17.7305V12.7305C13.0001 12.2 13.2108 11.6913 13.5858 11.3163C13.9609 10.9412 14.4696 10.7305 15.0001 10.7305H18.0001C18.0001 8.60874 17.1572 6.57391 15.6569 5.07362C14.1566 3.57332 12.1218 2.73047 10.0001 2.73047Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedAudioActive);
export default __webpack_public_path__ + "static/media/guided-audio-active.c0c0eea808bf43084a511545d2018fd0.svg";
export { ForwardRef as ReactComponent };